export default "__VITE_ASSET__DNxJqpg0__"